<ng-container *transloco="let t">
  <p class="regular">
    <span class="fw-medium">
       <app-language-output [hrLabel]="raceAdditionalPricingItem?.name"
                            [enLabel]="raceAdditionalPricingItem?.nameEng"
                            [itLabel]="raceAdditionalPricingItem?.nameIta"
                            [siLabel]="raceAdditionalPricingItem?.nameSlo"
                            [srLabel]="raceAdditionalPricingItem?.nameSr"
                            [bsLabel]="raceAdditionalPricingItem?.nameBs"
                            [defaultLanguage]="defaultLanguage" [languages]="languages"/>
    </span>
    @if (raceAdditionalPricingItem?.pricingItemValues?.length === 1) {
      {{ ' : ' }}
      <app-language-output [hrLabel]="raceAdditionalPricingItem!.pricingItemValues![0].name"
                           [enLabel]="raceAdditionalPricingItem!.pricingItemValues![0].nameEng"
                           [itLabel]="raceAdditionalPricingItem!.pricingItemValues![0].nameIta"
                           [siLabel]="raceAdditionalPricingItem!.pricingItemValues![0].nameSlo"
                           [srLabel]="raceAdditionalPricingItem!.pricingItemValues![0].nameSr"
                           [bsLabel]="raceAdditionalPricingItem!.pricingItemValues![0].nameBs"
                           [defaultLanguage]="defaultLanguage" [languages]="languages"/>
    }
    {{ price }}
  </p>
</ng-container>
